import Box from '@mui/material/Box';
import { Styles } from '@t2c/shared-fe';
import React, { Fragment, useState } from 'react';
import Stack from '@mui/material/Stack';
import { CircularProgress, Typography } from '@mui/material';
import { ContentType, EMPTY_PAGE_TEXT } from '../../../t2c-fe/utils';
import EmptyPage from '../../../t2c-fe/Common/EmptyPage';
import { useRouter } from 'next/router';
import { Button } from '@mui/material';
import { Grid } from '@mui/material';
import { AIMedia, AIMediaStatus, UploadTypes } from '../../../t2c-fe/@types';
import { BrollClipCard } from './BrollClipCard';
import { FiltersAndSorting } from '../../../t2c-fe/Common/FiltersAndSorting';
import { FetchBrollCaptionParams } from '../../../t2c-fe/services/broll-caption/fetchBrollCaptionData';
import { InfiniteData } from '@tanstack/react-query';
import InfiniteScroll from 'react-infinite-scroll-component';

interface Props {
  data: InfiniteData<AIMedia[]>;
  isLoading: boolean;
  refetch: () => void;
  allVideos?: boolean;
  params?: FetchBrollCaptionParams;
  setParams?: (_: FetchBrollCaptionParams) => void;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
}
export const BrollClipsSection = ({
  data,
  isLoading,
  refetch,
  allVideos,
  params,
  setParams,
  fetchNextPage,
  hasNextPage,
}: Props) => {
  const { push } = useRouter();

  const handleViewAll = () => {
    push('/broll');
  };

  const filterOptions = [
    {
      id: 1,
      name: 'In queue',
      value: AIMediaStatus.NotStarted,
    },
    {
      id: 2,
      name: 'Generating',
      value: AIMediaStatus.InProgress,
    },
    {
      id: 3,
      name: 'Generated',
      value: AIMediaStatus.Success,
    },
    {
      id: 4,
      name: 'Failed',
      value: AIMediaStatus.Error,
    },
  ];

  const handleFilterOptionChange = (val: AIMediaStatus) => {
    setParams({ ...params, filters: { status: val } });
  };

  return (
    <Stack rowGap={3} pb={2} mt={4}>
      {!allVideos && (
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5">Recent Creations</Typography>
          <Button onClick={handleViewAll}>View All</Button>
        </Box>
      )}

      {allVideos && (
        <Box display={'flex'} justifyContent={'flex-end'}>
          <FiltersAndSorting
            params={params}
            setParams={setParams}
            filterArray={filterOptions}
            handleFilterOptionChange={handleFilterOptionChange}
          />
        </Box>
      )}

      {isLoading ? (
        <Stack sx={styles.loader}>
          <CircularProgress />
        </Stack>
      ) : !(data?.pages?.[0] ?? []).length ? (
        <EmptyPage text={EMPTY_PAGE_TEXT.video} type={ContentType.Video} />
      ) : (
        <Box>
          {allVideos ? (
            <InfiniteScroll
              dataLength={data?.pages?.reduce((acc, page) => acc + page.length, 0) || 0}
              next={fetchNextPage}
              hasMore={hasNextPage}
              loader={
                <Box p={2} textAlign={'center'}>
                  <h2>loading...</h2>
                </Box>
              }
            >
              <Grid container spacing={4}>
                {data?.pages?.map((page, pageIndex) => (
                  <Fragment key={pageIndex}>
                    {page.map((res) => (
                      <Grid item flex={1} xs={12} sm={6} md={4} lg={3} key={res.id}>
                        <BrollClipCard data={res} refreshBrollData={refetch} />
                      </Grid>
                    ))}
                  </Fragment>
                ))}
              </Grid>
            </InfiniteScroll>
          ) : (
            <Grid container spacing={4}>
              {data?.pages?.map((page, pageIndex) => (
                <Fragment key={pageIndex}>
                  {page.map((res) => (
                    <Grid item flex={1} xs={12} sm={6} md={4} lg={3} key={res.id}>
                      <BrollClipCard data={res} refreshBrollData={refetch} />
                    </Grid>
                  ))}
                </Fragment>
              ))}
            </Grid>
          )}
        </Box>
      )}
    </Stack>
  );
};

const styles: Styles = {
  cardContainer: {
    minHeight: 180,
  },
  card: {
    width: 360,
  },
  loader: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20%',
  },
};
